import { Reducer } from "redux";
import MarketingConsentsState from "./MarketingConsentsState";
import { MarketingConsentsActionTypes, MarketingConsentsAction } from "./MarketingConsentsActions";

const initialState: MarketingConsentsState = {
  closedByCustomerId: {}
};

const MarketingConsentsReducer: Reducer<MarketingConsentsState, MarketingConsentsAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case MarketingConsentsActionTypes.SET_CLOSED_DIALOG: {
      const { customerId, isClosedDialog } = action.data;
      return {
        ...state,
        closedByCustomerId: {
          ...state.closedByCustomerId,
          [customerId]: isClosedDialog
        }
      };
    }
    default:
      return state;
  }
};

export default MarketingConsentsReducer;